function getMessage(field, [min]) {
  return `The ${field} field must be ${min} or more.`
}

function validate(value, [min]) {
  if (Array.isArray(value) || value === null || value === undefined || value === '') {
    return false
  }
  // Remove thousand seperator
  value = '' + value // If a format other den str, it doesnt has replace
  const valueWithoutMask = value.replace(/,/g, '')
  return Number(valueWithoutMask) >= min
}

export default {
  getMessage,
  validate
}
